import { computed } from 'vue';
import { useInjectVariant } from '../VariantContext';
/**
 * Resolve component variant (antd ≥ 5.13).
 * Priority: `variant` prop > `bordered={false}` → borderless > ConfigProvider.variant > outlined.
 */
export default function useVariant(props) {
    const contextVariant = useInjectVariant();
    return computed(() => {
        if (props.variant) {
            return props.variant;
        }
        if (props.bordered === false) {
            return 'borderless';
        }
        return contextVariant.value || 'outlined';
    });
}
